var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "notification" } }, [
    _vm.type && _vm.type.length
      ? _c(
          "div",
          { class: _vm.classes, attrs: { "data-cy": "feedback-notification" } },
          [
            _vm.icon || _vm.type
              ? _c("c-icon", {
                  staticClass: "icon",
                  attrs: { icon: _vm.icon || _vm.icons[_vm.type], size: "21" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "favorite" || _vm.type === "like"
              ? _c("section", { staticClass: "content" }, [
                  _c("p", { staticClass: "text" }, [
                    _c("b", [_vm._v("Oferta " + _vm._s(_vm.title))]),
                    _c("br", { staticClass: "notificationBR" }),
                    _vm._v(" " + _vm._s(_vm.text) + "\n      ")
                  ])
                ])
              : _c("section", { staticClass: "content" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text" }, [
                    _vm._v("\n        " + _vm._s(_vm.text) + "\n      ")
                  ])
                ]),
            _vm._v(" "),
            _c("c-button", {
              staticClass: "close",
              attrs: { "light-grey": "", size: "md", icon: "cross" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20311932", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20311932","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CFeedback.vue
// module id = 2193
// module chunks = 1610